(() => {
  const apply = () => {
    const d = document.querySelector('cart-drawer'); if (!d) return;
    const bar = d.querySelector('.nb-ship__bar'), lab = d.querySelector('.nb-ship__label');
    const free = !!bar && bar.getAttribute('aria-valuenow') === '100';
    if (lab && free) {
      if (lab.textContent !== 'Congrats! You’ve unlocked') lab.textContent = 'Congrats! You’ve unlocked';
      if (!lab.classList.contains('is-done')) lab.classList.add('is-done');
    }
    d.querySelectorAll('.nb-ci-eb').forEach((r) => {
      const ps = r.querySelectorAll('.cart-item__totals .price'), fin = ps.length ? ps[ps.length - 1].textContent.trim() : '';
      const st = r.querySelector('.nb-ci-price strong');
      if (st && fin && !/^[^0-9]*0[.,]00/.test(fin) && st.textContent !== fin) st.textContent = fin;
    });
    const row = d.querySelector('[data-nb-ship-row]');
    if (row) {
      const t = free ? 'FREE' : 'Calculated at checkout';
      if (row.textContent !== t) row.textContent = t;
      row.classList.toggle('is-free', free);
    }
  };
  const root = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  const post = async (url, body) => {
    body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname;
    const r = await fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json(); if (!r.ok || !data.sections) throw new Error('cart');
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents) { drawer.classList.toggle('is-empty', data.item_count === 0); drawer.renderContents(data); }
    return data;
  };
  const ss = (k, v) => { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } };
  let ebBusy = false;
  const ebook = async () => {
    const d = document.querySelector('cart-drawer'); if (!d || ebBusy) return;
    if (d.classList.contains('is-empty')) { ss('nbEb', null); return; }
    if (!d.classList.contains('active')) return;
    const need = d.querySelector('[data-nb-ebook-add]'), orphan = d.querySelector('[data-nb-ebook-orphan]');
    try {
      if (orphan) { ebBusy = true; await post('/cart/change.js', { line: +orphan.dataset.line, quantity: 0 }); }
      else if (need && !ss('nbEb')) { ebBusy = true; ss('nbEb', '1'); await post('/cart/add.js', { items: [{ id: +need.dataset.nbEbookAdd, quantity: 1 }] }); }
    } catch (e) {} finally { ebBusy = false; }
  };
  const start = () => {
    const d = document.querySelector('cart-drawer'); if (!d || d.__nbd) return; d.__nbd = 1;
    apply(); new MutationObserver(() => { apply(); setTimeout(ebook, 50); }).observe(d, { childList: true, subtree: true });
    new MutationObserver(() => setTimeout(ebook, 50)).observe(d, { attributes: true, attributeFilter: ['class'] });
  };
  document.addEventListener('click', async (e) => {
    const up = e.target.closest('[data-nb-upgrade]'), add = e.target.closest('[data-nb-add]');
    const btn = up || add; if (!btn || btn.disabled) return;
    e.preventDefault(); btn.disabled = true;
    const body = up
      ? { line: +up.dataset.line, quantity: +up.dataset.qty, selling_plan: +up.dataset.plan }
      : { items: [{ id: +add.dataset.nbAdd, quantity: 1 }] };
    try {
      await post(up ? '/cart/change.js' : '/cart/add.js', body);
    } catch (err) { location.href = root() + '/cart'; }
  });
  let ebPrice = null;
  const fmt = (c) => '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100));
  const tagBooks = () => {
    if (!ebPrice) return;
    document.querySelectorAll('.nb-bx__card--book').forEach((c) => { if (!c.querySelector('.nb-bx__val')) { const s = document.createElement('s'); s.className = 'nb-bx__val'; s.textContent = fmt(ebPrice); c.prepend(s); } });
  };
  const books = () => {
    const t = document.getElementById('nb-eb-card'); if (!t) return;
    document.querySelectorAll('.nb-bx').forEach((bx) => { if (!bx.querySelector('.nb-bx__card--book')) bx.appendChild(t.content.cloneNode(true)); });
    if (ebPrice) return tagBooks();
    if (!document.querySelector('.nb-bx__card--book')) return;
    fetch(root() + '/products/the-calm-pet-home-guide-free-e-book.js').then((r) => r.json()).then((p) => { if (p && p.price > 0) { ebPrice = p.price; tagBooks(); } }).catch(() => {});
  };
  const boot = () => { start(); books(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', books);
})();
